// extracted by mini-css-extract-plugin
export default {"container":"DevLoginPage_container__HwWNN","card":"DevLoginPage_card__Vm57n","title":"DevLoginPage_title__fyCIu"};